import store from "../store";
import { PROMO_SALES } from "../config/constants";

const domain = process.env.MIX_COOKIE_DOMAIN;

export function urlDontRequireAuth(config) {
	const urlsWithoutAuth = [
		"login",
		"signup",
		"validate-email",
		"validate-username"
	];

	return urlsWithoutAuth.find(url => config.url.includes(url));
}

export function setUserData(user) {
	localStorage.setItem("userData", JSON.stringify(user));

	_learnq.push(["identify", {
		"$email" : user.email,
		"$id" : Cookies.get("klabld_id"),
		"$username" : user.username
	}]);

	const expires = user.session_expires;
	Cookies.set("id", user.id, { expires, domain });
	Cookies.set("username", user.username, { expires, domain });
	Cookies.set("email", user.email, { expires, domain });
	Cookies.set("photo", user.photo, { expires, domain });
	Cookies.set("dob", user.dob, { expires, domain });
	Cookies.set("location", user.location, { expires, domain });

	if (user.multipasslogin) {
		Cookies.set("multipasslogin", user.multipasslogin, { expires, domain });
	}

	if (user.token) {
		Cookies.set("token", user.token, { expires, domain });
	}

	if (user.cookies_id) {
		Cookies.set("cookies_id", user.cookies_id, { expires, domain });
	}

	EventBus.$emit("user-logged-in", user);
}


export function getUserData() {
	return {
		cookies_id: Cookies.get("cookies_id") || "",
		dob: Cookies.get("dob") || "",
		email: Cookies.get("email") || "",
		id: Cookies.get("id") || "",
		location: Cookies.get("location") || "",
		multipasslogin: Cookies.get("multipasslogin") || "",
		photo: Cookies.get("photo") || "",
		username: Cookies.get("username") || "",
		token: Cookies.get("token") || "",
		social_auth_user: Cookies.get("social_auth_user") || ""
	};
}

/**
 * @deprecated use setUserData instead
 *
 * @export
 * @param {*} user
 */
export function loginSuccessHandler(user) {
	setUserData(user);
}

export async function clearUserData() {
	await store.dispatch("saveUserData", {});
	localStorage.removeItem("userData");

	// We set path property empty cause we have to delete the cookies in all domains
	Cookies.remove("id", { domain });
	Cookies.remove("username", { domain });
	Cookies.remove("email", { domain });
	Cookies.remove("photo", { domain });
	Cookies.remove("dob", { domain });
	Cookies.remove("location", { domain });
	Cookies.remove("multipasslogin", { domain });
	Cookies.remove("cookies_id", { domain });
	Cookies.remove("token", { domain });
	Cookies.remove("social_auth_user", { domain });
}

export function isMobile(includeIpad = false) {
	const mobileNavigators = [
		"Android",
		"webOS",
		"iPhone",
		"iPod",
		"BlackBerry",
		"Windows Phone"
	];

	let isMobile = mobileNavigators.some((mobileNavigator) => navigator.userAgent.includes(mobileNavigator));

	if (includeIpad) {
		isMobile = isMobile ||
            navigator.userAgent.includes("iPad") ||
            navigator.userAgent.includes("Mac OS X") && window.orientation !== undefined;
	}

	return isMobile;
}

export function deviceType() {
	return isMobile() ? "mobile" : "desktop";
}

export function isUserLoggedIn() {
	return Cookies.get("cookies_id");
}

export function datesAreInRange(from, to, timezone = "America/Los_Angeles") {
	if (!moment.tz.names().includes(timezone)) {
		// eslint-disable-next-line no-console
		console.error(`The timezone "${timezone}" is not valid.`);
		return;
	}

	const dateTimeFormat = "YYYY-MM-DD HH:mm:ss";
	from = moment.tz(from, dateTimeFormat, timezone);
	to = moment.tz(to, dateTimeFormat, timezone);

	return moment.tz(timezone).isBetween(from, to);
}

export function hasOverflow(element) {
	const currentOverflow = element.style.overflow;

	if (!currentOverflow || currentOverflow === "visible") {
		element.style.overflow = "hidden";
	}

	const isOverflowing = element.clientWidth < element.scrollWidth || element.clientHeight < element.scrollHeight;

	element.style.overflow = currentOverflow;

	return isOverflowing;
}

export function onTouchStartMakeClick(className, callback) {
	const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
	if (iOS) {
		$(className).on("touchstart click", callback);
	}
}

export function promoDiscount(price) {
	const decimalPrice = window.accounting.toFixed(parseFloat(price), 2);
	const discount = decimalPrice - PROMO_SALES.DISCOUNT_PRICE;
	return window.accounting.toFixed(discount, 2);
}

export function casePromo(build) {
	return !Number(build.is_limited) && (build.cases == PROMO_SALES.DISCOUNT_ITEM_NAME || build.name == PROMO_SALES.DISCOUNT_ITEM_NAME);
}
